/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type AssetModel = {
    AssetId?: string;
    Description?: string;
    AdditionalDescription?: Array<string>;
    AssetType?: AssetModel.AssetType;
    AssetValueType?: AssetModel.AssetValueType;
    LastModifiedDate?: string;
    LastValuationDate?: string;
    UnitValue?: number;
};
export namespace AssetModel {
    export enum AssetType {
        REAL_ESTATE = 'RealEstate',
        PUBLIC_LLC = 'PublicLLC',
        PRIVATE_LLC = 'PrivateLLC',
        OTHER_CASH = 'OtherCash',
        METALS_AND_CURRENCY = 'MetalsAndCurrency',
        MUTUAL_FUNDS = 'MutualFunds',
        TEMPORARY_IRALOAN = 'TemporaryIRALoan',
        MORTGAGE_DEBT = 'MortgageDebt',
        TRUSTS = 'Trusts',
        STOCK = 'Stock',
        CASH = 'Cash',
        BONDS = 'Bonds',
        EXTRAORDINARY = 'Extraordinary',
    }
    export enum AssetValueType {
        UNKNOWN = 'Unknown',
        CUSTODIAL_CASH = 'CustodialCash',
        CUSTODIAL_MONEY_FUND = 'CustodialMoneyFund',
        SHARE_BASED = 'ShareBased',
        DOLLAR_BASED = 'DollarBased',
        NOTE = 'Note',
        BROKERAGE_ACCOUNT = 'BrokerageAccount',
    }
}

